import PropTypes from "prop-types";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import typography from "assets/theme/base/typography";
import version from '../../../../version';

function Footer({ light }) {
  const { size } = typography;

  return (
    <MDBox position="fixed" width="100%" bottom={0} py={4} zIndex={-1} sx={{ pointerEvents: "auto" }}>
      <MDBox
        width="100%"
        display="flex"
        flexDirection={{ xs: "column", lg: "row" }}
        justifyContent="space-between"
        alignItems="center"
        px={1.5}
      >
        <MDBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexWrap="wrap"
          color={light ? "text" : "text"}
          fontSize={size.sm}
        >
          &copy; {new Date().getFullYear()}, YouCloud Technology.
        </MDBox>
        <MDBox
          component="ul"
          sx={({ breakpoints }) => ({
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
            listStyle: "none",
            mt: 3,
            mb: 0,
            p: 0,
            [breakpoints.up("lg")]: {
              mt: 0,
            },
          })}
        >
          <MDBox component="li" px={2} lineHeight={1}>
            <MDTypography
              variant="button"
              fontWeight="regular"
              color={light ? "dark" : "dark"}
            >
              Version {version || "N/A"}
            </MDTypography>
          </MDBox>
        </MDBox>
      </MDBox>
    </MDBox>
  );
}

// Setting default props for the Footer
Footer.defaultProps = {
  light: false,
};

// Typechecking props for the Footer
Footer.propTypes = {
  light: PropTypes.bool,
};

export default Footer;
